import { render } from "./GameRounded.vue?vue&type=template&id=7f9cc3a5&scoped=true"
import script from "./GameRounded.vue?vue&type=script&lang=js"
export * from "./GameRounded.vue?vue&type=script&lang=js"

import "./GameRounded.vue?vue&type=style&index=0&id=7f9cc3a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9cc3a5"]])

export default __exports__